// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__JpZX-","dragIcon":"SortableItem_dragIcon__14Fvq","disabled":"SortableItem_disabled__3QuXG"};